import { Box, Button, Checkbox, FormControlLabel, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'

import { useStyles } from '../styles'
import {
  IAccountByIdRawRespDto,
  IScanToEarnSettingsConfirmModal,
  IScanToEarnSettingsModal,
} from 'src/types'
import { ChangeEvent, useEffect, useState } from 'react'
import { useAllAccountsRaw, useGetExistingAccountsForConsumerScan } from 'src/hooks'
import { AccountsSelection } from './existing-accounts-selection.component'

interface IProps {
  open: boolean
  handleClose: () => void
  data: IScanToEarnSettingsModal | null
  handleConfirm: (data: IScanToEarnSettingsConfirmModal) => void
}

export const ScanToEarnSettingsModal = ({ open, handleClose, data, handleConfirm }: IProps) => {
  const [createAccount, setCreateAccount] = useState(true)
  const [createProduct, setCreateProduct] = useState(true)

  const [selectedAccount, setSelectedAccount] = useState<IAccountByIdRawRespDto | null>(null)

  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  const { data: accountMatchData, isLoading: isAccounrMatchDataLoading } =
    useGetExistingAccountsForConsumerScan(data?.consumerScanId)

  const { data: accounts } = useAllAccountsRaw({
    columns: ['website'],
    relations: ['socials'],
    sortBy: 'account_holder',
    sortingOrder: 'ASC',
  })

  const setInitialState = () => {
    setCreateAccount(true)
    setSelectedAccount(null)
  }

  // useEffect(() => {
  //   setInitialState()
  // }, [open])

  useEffect(() => {
    if (accountMatchData && !isAccounrMatchDataLoading) {
      if (accountMatchData.matchedAccount) {
        setCreateAccount(false)
        setSelectedAccount(accountMatchData.matchedAccount as IAccountByIdRawRespDto)

        return
      }

      if (accountMatchData.bestMatchByNameAccount) {
        setCreateAccount(false)
        setSelectedAccount(accountMatchData.bestMatchByNameAccount as IAccountByIdRawRespDto)
      }
    }
  }, [isAccounrMatchDataLoading, accountMatchData, open])

  if (!data) {
    return null
  }

  const handleAccountSelect = (account: IAccountByIdRawRespDto) => {
    setCreateAccount(false)
    setSelectedAccount(account)
  }

  const handleAccountChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedAccount(null)
    }

    setCreateAccount(e.target.checked)
  }
  const handleProductChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCreateProduct(e.target.checked)
  }

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        setInitialState()
        handleClose()
      }}
      className={classes.settingsModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '2px',
          alignItems: 'start',
        }}
      >
        <Typography
          fontWeight={500}
          sx={{
            fontSize: '18px',
            width: '100%',
            textAlign: 'center',
            color: theme.palette.custom.darkBlue2,
            mb: '20px',
            mt: '5px',
            mx: '3px',
          }}
        >
          Choose entities to create
        </Typography>

        {!!accounts?.data && accounts.data?.length > 0 && (
          <AccountsSelection
            accounts={accounts.data || []}
            handleAccountSelect={handleAccountSelect}
            selectedAccount={selectedAccount}
          />
        )}

        <FormControlLabel
          style={{ color: theme.palette.text.primary, justifyContent: 'start' }}
          control={
            <Checkbox
              name="create_account"
              checked={createAccount}
              onChange={handleAccountChange}
            />
          }
          label={'Create account:'}
          labelPlacement="start"
          // disabled={data.accountExists}
        />
        <FormControlLabel
          style={{ color: theme.palette.text.primary, justifyContent: 'start' }}
          control={
            <Checkbox
              name="create_product"
              checked={createProduct}
              onChange={handleProductChange}
            />
          }
          label={'Create product:'}
          labelPlacement="start"
          disabled
        />

        {/* <Typography
            variant="body1"
            sx={{
              color: theme.palette.custom.darkBlue2,
            }}
          >
            Crete product:{data.productExists.toString()}
          </Typography> */}
      </Box>
      <Box sx={{ width: '100%', textAlign: 'center', pt: '10px' }}>
        <Button
          onClick={() => {
            handleConfirm({
              createAccount: createAccount,
              createProduct: createProduct,
              accountName: createAccount ? data.accountName : '',
              productName: createProduct ? data.productName : '',
              consumerScanId: data.consumerScanId,
              selectedAccountId: selectedAccount?.id || null,
            })
          }}
          variant="contained"
          size="small"
          disabled={(!createAccount && !selectedAccount) || (!!selectedAccount && !createProduct)}
        >
          Create
        </Button>
      </Box>
    </ModalWrapper>
  )
}
